package eu.codlab.navigation

import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import androidx.compose.ui.unit.dp
import androidx.navigation.compose.NavHost
import com.nonopn.skywatcher.design.utils.LocalFrameProvider
import com.nonopn.skywatcher.design.utils.LocalWindow
import com.nonopn.skywatcher.design.utils.WindowType
import com.nonopn.skywatcher.design.widgets.BackgroundWrapper
import com.nonopn.skywatcher.design.widgets.BottomSpacer
import eu.codlab.platform.Platform
import eu.codlab.platform.currentPlatform

typealias DrawerContentCallback = @Composable (
    modifier: Modifier,
    onMenuItemSelected: (title: String, navigateTo: NavigateTo) -> Unit,
    tiny: Boolean,
) -> Unit

@Composable
fun ScaffoldContentWrapper(
    possibleRoutes: List<Router<*>>,
    defaultRoute: RouteParameterTo,
    onMenuItemSelected: (title: String, navigateTo: NavigateTo) -> Unit,
    drawerContent: DrawerContentCallback? = null,
) {
    val keyboardController = LocalSoftwareKeyboardController.current
    val focusManager = LocalFocusManager.current
    val navigator = LocalNavigator.current
    val tinyMenuInPhablet = LocalWindow.current == WindowType.PHABLET
    val interactionSource = remember { MutableInteractionSource() }
    val menuSizeForPhablet = if (tinyMenuInPhablet) {
        42.dp
    } else {
        250.dp
    }

    val actualNavigator = navigator.navigator ?: return

    Row(modifier = Modifier.fillMaxSize()) {
        // no drawer content just for now
        drawerContent?.let {
            if (!LocalWindow.current.isScreenExpanded()) return@let

            it(
                Modifier
                    .padding()
                    .fillMaxHeight()
                    .width(menuSizeForPhablet),
                onMenuItemSelected,
                tinyMenuInPhablet,
            )
        }

        LocalFrameProvider(
            modifier = Modifier.fillMaxSize()
        ) {
            BackgroundWrapper(
                modifier = Modifier.fillMaxSize().clickable(
                    interactionSource = interactionSource,
                    indication = null // this gets rid of the ripple effect
                ) {
                    if (currentPlatform != Platform.JVM) {
                        keyboardController?.hide()
                        focusManager.clearFocus(true)
                    }
                }
            ) {
                Column(modifier = Modifier.weight(1f)) {
                    NavHost(
                        navController = actualNavigator,
                        startDestination = defaultRoute,
                        modifier = Modifier.fillMaxSize().imePadding(),
                    ) {
                        possibleRoutes.forEach { router ->
                            router.display(this)
                        }
                    }

                    BottomSpacer()
                }
            }
        }
    }
}
